import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const ProtectedRoute = ({ allowedRoles }) => {
  const { user } = useSelector((state) => state.auth);
  const location = useLocation();

  let userRoles = [];

  if (user?.operator?.roles?.length > 0) {
    userRoles = user.operator.roles.map((e) => e.name);
  } else if (user?.operator?.role) {
    userRoles = [user.operator.role]; 
  }

  const isAuthorized = userRoles.some((role) => allowedRoles.includes(role));

  return isAuthorized ? (
    <Outlet />
  ) : user ? (
    <Navigate to="/NotFound" state={{ from: location }} replace />
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
};

export default ProtectedRoute;
